import { useMemo } from 'react';
import { useIsUserAuthenticated } from '@/hooks/useIsUserAuthenticated';
import { getConfirmedUserId } from '@/lib/auth/tokenStorage';

// gloss
const getFanUserID = (): string | null => (typeof window === 'undefined' ? null : getConfirmedUserId());

// gloss
type UseAuthReadyOptions = {
  requireUserID?: boolean;
  gates?: unknown[];
};

export const useAuthReady = ({ requireUserID = true, gates = [] }: UseAuthReadyOptions = {}) => {
  const isAuthenticated = useIsUserAuthenticated();
  const fanUserID = useMemo(getFanUserID, [isAuthenticated]);
  const isAuthReady = isAuthenticated && (!requireUserID || !!fanUserID) && gates.every((gate) => Boolean(gate));

  return { isAuthReady, fanUserID };
};
